import { Store } from './store';

export const STORES: Store[] = [
  { 
  	"store" : "Oxxo", 
  	"image":"/assets/img/pagos/oxxo.png",
  	"url":"oxxo"
  },
  { 
  	"store" : "7 Eleven", 
  	"image":"/assets/img/pagos/7eleven.png",
  	"url":"7eleven"
  },
  { 
  	"store" : "Extra", 
  	"image":"/assets/img/pagos/extra.png",
  	"url":"extra"
  },
  { 
  	"store" : "Circle K", 
  	"image":"/assets/img/pagos/circlek.png",
  	"url":"circlek"
  },
  { 
  	"store" : "Walmart", 
  	"image":"/assets/img/pagos/walmart.png",
  	"url":"walmart"
  },
  { 
  	"store" : "Bodega Aurrera", 
  	"image":"/assets/img/pagos/aurrera.png",
  	"url":"aurrera"
  },
  { 
  	"store" : "Superama", 
  	"image":"/assets/img/pagos/superama.png",
  	"url":"superama"
  },
  { 
  	"store" : "Farmacias del Ahorro", 
  	"image":"/assets/img/pagos/ahorro.png",
  	"url":"ahorro"
  },
  { 
  	"store" : "Farmacias Guadalajara", 
  	"image":"/assets/img/pagos/guadalajara.png",
  	"url":"guadalajara"
  },
  { 
  	"store" : "Sams", 
  	"image":"/assets/img/pagos/sams.png",
  	"url":"sams"
  },
  { 
  	"store" : "Farmacias Benavides", 
  	"image":"/assets/img/pagos/benavides.png",
  	"url":"benavides"
  },
   { 
  	"store" : "Waldos", 
  	"image":"/assets/img/pagos/waldos.png",
  	"url":"waldos"
  },
   { 
  	"store" : "Al super", 
  	"image":"/assets/img/pagos/al-super.png",
  	"url":"al-super"
  },
   { 
  	"store" : "Asturiano", 
  	"image":"/assets/img/pagos/asturiano.png",
  	"url":"asturiano"
  },
   { 
  	"store" : "Air Pak", 
  	"image":"/assets/img/pagos/airpak.png", 
  	"url":"airpak"
  },
   { 
  	"store" : "Kiosko", 
  	"image":"/assets/img/pagos/kiosko.png",
  	"url":"kiosko"
  },
   { 
  	"store" : "Maxilana", 
  	"image":"/assets/img/pagos/maxilana.png",
  	"url":"maxilana"
  },
   { 
  	"store" : "Multi Recargas", 
  	"image":"/assets/img/pagos/multi-recargas.png",
  	"url":"multi-recargas"
  },
   { 
  	"store" : "Prenda Mex", 
  	"image":"/assets/img/pagos/prendamex.png",
  	"url":"prendamex"
  },
   { 
  	"store" : "Red Efectiva", 
  	"image":"/assets/img/pagos/red-efectiva.png",
  	"url":"red-efectiva"
  },
   { 
  	"store" : "Te Creemos", 
  	"image":"/assets/img/pagos/te-creemos.png",
  	"url":"te-creemos"
  },
   { 
  	"store" : "Gestopago", 
  	"image":"/assets/img/pagos/gestopago.png",
  	"url":"gestopago"
  }
]